// Legal Analysis tab content. Thin wrapper
// around the shared <AnalystTabContent lane="A3" /> shell.
import type { DealDetailDto } from "@/types/deals";
import { AnalystTabContent } from "./AnalystTabContent";

interface LegalAnalysisTabContentProps {
  deal: DealDetailDto;
}

export function LegalAnalysisTabContent({
  deal,
}: LegalAnalysisTabContentProps) {
  return <AnalystTabContent deal={deal} lane="A3" />;
}
